import {
  amendOrderFromParams as upstreamAmendOrderFromParams
} from 'customer-flows/gql/mutations/amend-order-from-params'

export default function order({ callerContext, services, stores }: CommandArgs) {
  const orderStore = stores['order'] as OrderStore
  const quoteBuilder = services['quoteBuilder'] as QuoteBuilder
  const sessionService = services['session']

  function setOrder(order: Order) {
    orderStore.order = order
  }

  /**
   * amends an order by updating custom questions for booking quotes and their tickets
   * @returns Promise with the amended order
   */
  function amendOrderWithCustomQuestions(): Promise<Order | undefined> {
    const orderId = orderStore.orderId

    if (!orderId) {
      throw new Error('No orderId found in order store')
    }

    // build quote only non-mandatory question answers
    quoteBuilder
      .include('questionAnswers', ['nonMandatory'])
      .include('tickets', ['withNonMandatoryQuestionAnswers'])
      .compose('bookingQuotes')

    if (!quoteBuilder.isValid) {
      throw new Error('Invalid quote input for amending order')
    }

    const quoteInput = quoteBuilder.input

    const input = {
      orderId,
      quoteInput
    }

    // we need to get a new session id for order mutations to prevent errors
    sessionService.resetId()

    return upstreamAmendOrderFromParams(callerContext, input)
      .then((response) => {
        const result = response?.amendOrderFromParams

        if (result?.__typename === 'GenericError' ||
          result?.__typename === 'InvalidDataError' ||
          result?.__typename === 'NotFoundError'
        ) {
          throw new Error('Failed to amend order', {cause: result})
        }

        if (result?.__typename === 'AmendOrderFromParamsSuccess') {
          return result.order
        }

        return undefined
      })
      .catch((e) => {
        throw e
      })
  }

  return {
    amendOrderWithCustomQuestions,
    setOrder
  }
}

declare global {
  export type OrderCommands = ReturnType<typeof order>

  // Add to global scope
  interface CommandRegistry {
    'order': OrderCommands
  }
}
